"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStateAnimation = useStateAnimation;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useStateAnimation(parentSetState) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useMemo = (0, _react.useMemo)(function () {
    var timer;

    var innerclose = function innerclose(v) {
      setState(v);
      timer = window.setTimeout(function () {
        parentSetState(v);
        setState(true);
      }, delay);
    }; // eslint-disable-next-line no-shadow


    // eslint-disable-next-line no-shadow
    var unmount = function unmount() {
      return window.clearTimeout(timer);
    };

    return [innerclose, unmount];
  }, [setState, parentSetState, delay]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      innerClose = _useMemo2[0],
      unmount = _useMemo2[1];

  return [state, innerClose, unmount];
}